const auth_status = {
    page_title: 'Estado de autenticación',
    title: 'Estado de autenticación',
    description: 'Verifique el estado de la autenticación.',
};
export default Object.freeze(auth_status);
